import addFilter, { ADD_FILTER } from './addFilter';
import hideLoader, { HIDE_LOADER } from './hideLoader';
import redo, { REDO } from './redo';
import reset, { RESET } from './reset';
import setFeedback, { SET_FEEDBACK } from './setFeedback';
import showLoader, { SHOW_LOADER } from './showLoader';
import selectTab, { SELECT_TAB } from './selectTab';
import undo, { UNDO } from './undo';
import setFinetune, { SET_FINETUNE } from './setFinetune';
import clearFinetune, { CLEAR_FINETUNE } from './clearFinetune';
import setAnnotation, { SET_ANNOTATION } from './setAnnotation';
import updateZIndexAnnotations, { UPDATE_ZINDEX_ANNOTATIONS } from './updateZIndexAnnotations';
import reorderAnnotationsStacking, {
  REORDER_ANNOTATIONS_STACKING,
} from './reorderAnnotationsStacking';
import alignSelectedAnnotations, {
  ALIGN_SELECTED_ANNOTATIONS,
} from './alignSelectedAnnotations';
import moveAnnotations, { MOVE_ANNOTATIONS } from './moveAnnotations';
import groupSelectedAnnotations, {
  GROUP_SELECTED_ANNOTATIONS,
} from './groupSelectedAnnotations';
import ungroupSelectedAnnotations, {
  UNGROUP_SELECTED_ANNOTATIONS,
} from './ungroupSelectedAnnotations';
import setAnnotationsLock, { SET_ANNOTATIONS_LOCK } from './setAnnotationsLock';
import changePointerIcon, { CHANGE_POINTER_ICON } from './changePointerIcon';
import selectAnnotation, { SELECT_ANNOTATION } from './selectAnnotation';
import selectAllAnnotations, { SELECT_ALL_ANNOTATIONS } from './selectAllAnnotations';
import selectAnnotationsInRect, {
  SELECT_ANNOTATIONS_IN_RECT,
} from './selectAnnotationsInRect';
import clearAnnotationsSelections, { CLEAR_ANNOTATIONS_SELECTIONS, } from './clearAnnotationsSelections';
import toggleOriginalImageDisplay, { TOGGLE_ORIGINAL_IMAGE_DISPLAY, } from './toggleOriginalImageDisplay';
import selectTool, { SELECT_TOOL } from './selectTool';
import toggleFlip, { TOGGLE_FLIP } from './toggleFlip';
import setCrop, { SET_CROP } from './setCrop';
import changeRotation, { CHANGE_ROTATION } from './changeRotation';
import zoomCanvas, { ZOOM_CANVAS } from './zoomCanvas';
import setCanvasSize, { SET_CANVAS_SIZE } from './setCanvasSize';
import setOriginalImage, { SET_ORIGINAL_IMAGE } from './setOriginalImage';
import setShownImageDimensions, { SET_SHOWN_IMAGE_DIMENSIONS, } from './setShownImageDimensions';
import removeAnnotations, { REMOVE_ANNOTATIONS } from './removeAnnotations';
import duplicateAnnotations, { DUPLICATE_ANNOTATIONS, } from './duplicateAnnotations';
import enableTextContentEdit, { ENABLE_TEXT_CONTENT_EDIT, } from './enableTextContentEdit';
import setResize, { SET_RESIZE } from './setResize';
import setSaved, { SET_SAVED } from './setSaved';
import updateState, { UPDATE_STATE } from './updateState';
import setLatestColor, { SET_LATEST_COLOR } from './setLatestColor';
import setEditorPreferences, {
  SET_EDITOR_PREFERENCES,
} from './setEditorPreferences';

export default {
  [SET_ORIGINAL_IMAGE]: setOriginalImage,
  [SET_FEEDBACK]: setFeedback,
  [SHOW_LOADER]: showLoader,
  [HIDE_LOADER]: hideLoader,
  [CHANGE_POINTER_ICON]: changePointerIcon,
  [SELECT_ANNOTATION]: selectAnnotation,
  [SELECT_ALL_ANNOTATIONS]: selectAllAnnotations,
  [SELECT_ANNOTATIONS_IN_RECT]: selectAnnotationsInRect,
  [CLEAR_ANNOTATIONS_SELECTIONS]: clearAnnotationsSelections,
  [TOGGLE_ORIGINAL_IMAGE_DISPLAY]: toggleOriginalImageDisplay,
  [SELECT_TAB]: selectTab,
  [SELECT_TOOL]: selectTool,
  [ZOOM_CANVAS]: zoomCanvas,
  [SET_CANVAS_SIZE]: setCanvasSize,
  [SET_SHOWN_IMAGE_DIMENSIONS]: setShownImageDimensions,
  [ENABLE_TEXT_CONTENT_EDIT]: enableTextContentEdit,
  [SET_LATEST_COLOR]: setLatestColor,
  // Start of Design actions...
  [ADD_FILTER]: addFilter,
  [SET_FINETUNE]: setFinetune,
  [CLEAR_FINETUNE]: clearFinetune,
  [SET_ANNOTATION]: setAnnotation,
  [UPDATE_ZINDEX_ANNOTATIONS]: updateZIndexAnnotations,
  [REORDER_ANNOTATIONS_STACKING]: reorderAnnotationsStacking,
  [ALIGN_SELECTED_ANNOTATIONS]: alignSelectedAnnotations,
  [MOVE_ANNOTATIONS]: moveAnnotations,
  [GROUP_SELECTED_ANNOTATIONS]: groupSelectedAnnotations,
  [UNGROUP_SELECTED_ANNOTATIONS]: ungroupSelectedAnnotations,
  [SET_ANNOTATIONS_LOCK]: setAnnotationsLock,
  [SET_CROP]: setCrop,
  [CHANGE_ROTATION]: changeRotation,
  [TOGGLE_FLIP]: toggleFlip,
  [SET_RESIZE]: setResize,
  [REMOVE_ANNOTATIONS]: removeAnnotations,
  [DUPLICATE_ANNOTATIONS]: duplicateAnnotations,
  // End of Design actions.
  [UNDO]: undo,
  [REDO]: redo,
  [RESET]: reset,
  [SET_SAVED]: setSaved,
  [UPDATE_STATE]: updateState,
  [SET_EDITOR_PREFERENCES]: setEditorPreferences,
};

export {
  SET_ORIGINAL_IMAGE,
  SET_FEEDBACK,
  SHOW_LOADER,
  HIDE_LOADER,
  CHANGE_POINTER_ICON,
  SELECT_ANNOTATION,
  SELECT_ALL_ANNOTATIONS,
  SELECT_ANNOTATIONS_IN_RECT,
  CLEAR_ANNOTATIONS_SELECTIONS,
  TOGGLE_ORIGINAL_IMAGE_DISPLAY,
  SELECT_TAB,
  SELECT_TOOL,
  ZOOM_CANVAS,
  SET_CANVAS_SIZE,
  SET_SHOWN_IMAGE_DIMENSIONS,
  ENABLE_TEXT_CONTENT_EDIT,
  SET_LATEST_COLOR,
  // Start of Design actions...
  ADD_FILTER,
  SET_FINETUNE,
  CLEAR_FINETUNE,
  SET_ANNOTATION,
  REORDER_ANNOTATIONS_STACKING,
  ALIGN_SELECTED_ANNOTATIONS,
  MOVE_ANNOTATIONS,
  GROUP_SELECTED_ANNOTATIONS,
  UNGROUP_SELECTED_ANNOTATIONS,
  SET_ANNOTATIONS_LOCK,
  SET_CROP,
  CHANGE_ROTATION,
  TOGGLE_FLIP,
  SET_RESIZE,
  REMOVE_ANNOTATIONS,
  DUPLICATE_ANNOTATIONS,
  // End of Design actions.
  UNDO,
  REDO,
  RESET,
  SET_SAVED,
  UPDATE_STATE,
  SET_EDITOR_PREFERENCES,
};
